import Firebase from 'firebase'

const firebaseApp = Firebase.initializeApp({
  apiKey: "AIzaSyB0YsJ_LfJ0A1MRwlhw4QBNovuvCjZAmZk",
  authDomain: "getnet-c2357.firebaseapp.com",
  databaseURL: "https://getnet-c2357.firebaseio.com",
  projectId: "getnet-c2357",
  storageBucket: "getnet-c2357.appspot.com",
  messagingSenderId: "1069309486841"
});

export const db = firebaseApp.database();
export const storage = firebaseApp.storage();
export const auth = firebaseApp.auth();
export const fcm = firebaseApp.messaging();



// WEBPACK FOOTER //
// ./src/firebase/index.js